// extracted by mini-css-extract-plugin
export default {"content":"style_content__xGSxg","edditorError":"style_edditorError__u0Gn6"};